export default "__VITE_ASSET__BWctx8uu__"